import graphqlClient from './client';
import gql from 'graphql-tag';
import type { Bucket } from '../stores/JobApplicationStore/types';
import type { Prospect } from './types';

export const query = gql`
  query prospectBucketByAdcentreProspectId(
    $positionId: ID!
    $advertiserId: ID!
    $adcentreProspectId: ID!
  ) {
    prospectByAdcentreProspectId(
      input: {
        positionId: $positionId
        advertiserId: $advertiserId
        adcentreProspectId: $adcentreProspectId
      }
    ) {
      bucket
    }
  }
`;

interface Payload {
  prospectByAdcentreProspectId: Prospect;
}

const fetchProspectBucketByAdcentreProspectId = async (
  positionId: number,
  advertiserId: string, // seek web advertiser id
  adcentreProspectId: string,
): Promise<Bucket | undefined> => {
  const result = await graphqlClient.query<Payload>({
    variables: {
      positionId,
      advertiserId,
      adcentreProspectId,
    },
    query,
  });

  const prospect = result.data.prospectByAdcentreProspectId;

  return prospect?.bucket;
};

export default fetchProspectBucketByAdcentreProspectId;
